const SubmitCampaign = () => {

    return (
      <div>
        <div className="grid mt-4 mb-8">
          <span className="font-semibold">Step 5 of 5</span>
          <span className="text-secondary text-sm">Submit campaign</span>
        </div>
        <div className="w-full grid gap-6 mb-8">
          <div>
            <div className="font-bold">Campaign duration</div>
            <div className="text-secondary">
              Each campaign will run for 90 days from the date of approval.
              After 90 days, the campaign will be removed from the platform and
              payment will be processed. If you wish to extend your campaign,
              please contact Mosquepay via email <span className="text-brandGreen">[support@mosquepay.org]</span> before the end of the campaign
              period to discuss extension options.
            </div>
          </div>
          <div>
            <div className="font-bold">Agreement to terms</div>
            <div className="text-secondary">
              Before submitting your campaign, please ensure that you have
              read and agreed to <span className="underline text-brandGreen font-bold">Mosquepay's terms and conditions.</span> By continuing, you acknowledge that you understand and accept
              all the guidelines and responsibilities associated with creating a
              fundraising campaign on our platform.
            </div>
          </div>
        </div>
      </div>
    );
}
 
export default SubmitCampaign;